import { render } from "./TablaServiciosProgramadosOrganismos.vue?vue&type=template&id=092c035c&ts=true"
import script from "./TablaServiciosProgramadosOrganismos.vue?vue&type=script&lang=ts"
export * from "./TablaServiciosProgramadosOrganismos.vue?vue&type=script&lang=ts"

import "./TablaServiciosProgramadosOrganismos.vue?vue&type=style&index=0&id=092c035c&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__